import { useState } from "react";
import { getSupabase } from "@/lib/supabaseClient";
import { getStableSession } from "@/lib/getStableSession";
import { fetchUserRole } from "@/lib/getUserRole";
import { uploadViaEdge } from "@/lib/uploadViaEdge";

export function TestUploadButton({ productId }: { productId: string }) {
  const [msg, setMsg] = useState("");
  const [label, setLabel] = useState("Test Upload");

  async function run() {
    setMsg("");
    const supabase = getSupabase();
    const session = await getStableSession(supabase);
    const role = session ? await fetchUserRole(supabase) : null;

    setLabel(`Test Upload • session:${!!session} ${session?.user?.id ?? ""} • role:${role ?? "n/a"}`);

    try {
      const tiny = new Blob([Uint8Array.of(137,80,78,71, ...Array(60).fill(0))], { type: "image/png" });
      const res = await uploadViaEdge(tiny as File, productId);
      setMsg(`OK → ${res.publicUrl || res.path}`);
    } catch (e: any) {
      setMsg(`FAIL → ${(e?.message || String(e)).split("\n")[0]}`);
    }
  }

  return (
    <div className="flex items-center gap-2">
      <button onClick={run} className="btn">{label}</button>
      <span className="text-sm opacity-80">{msg}</span>
    </div>
  );
}
